import {registerLocalStorageVariable} from "@/helper/localstorage";
import {deserializeNullString} from "@/helper/serialize";
import moment from "moment";

registerLocalStorageVariable('authToken', {
    deserializer: deserializeNullString,
    storeLoader: (value, store) => store.state.authToken = value
  }
);

registerLocalStorageVariable('authRefreshToken', {
    deserializer: deserializeNullString,
    storeLoader: (value, store) => store.state.authRefreshToken = value
  }
);

registerLocalStorageVariable('currentLanguage', {
    deserializer: deserializeNullString,
    storeLoader: (value, store) => {
      store.state.currentLanguage = value
      if (value) {
        moment.locale(value);
      }
    }
  }
);

registerLocalStorageVariable('tokenData', {
    serializer : JSON.stringify,
    deserializer: JSON.parse,
    storeLoader: (value, store) => store.state.tokenData = value
  }
);

registerLocalStorageVariable('lastRefresh', {
    deserializer: (value) => {
      if (value === 'null' || value === 'undefined') return null
      return new Date(value)
    },
    storeLoader: (value, store) => store.state.lastRefresh = value
  }
);

registerLocalStorageVariable('preferredLipidsUnit', {
    deserializer: deserializeNullString,
    storeLoader: (value, store) => store.commit('user/setPreferredLipidsUnit', value)
  }
);

registerLocalStorageVariable('preferredGlucoseUnit', {
    deserializer: deserializeNullString,
    storeLoader: (value, store) => store.commit('user/setPreferredGlucoseUnit', value)
  }
);
